import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { GetVendorItemsPriceListResponse, ItemsDropDownDto, PriceListForVendorResponse, TaxDropDownDto, VendorPriceListCreateResponse, VendorPriceListDto } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { In } from 'typeorm';
import { VenPriceListAdapter } from './adapters/vendor-price-list.adapter';
import { VPLActivateOrDeActiveRequest } from './dto/activate-deactivate.request';
import { VendorItemRequestDto } from './dto/vendor-item.request';
import { VendorPriceListInfo } from './dto/vendors-price-list-info';
import { VendorsPriceListRepository } from './repositories/vendor-price-list.repository';

@Injectable()
export class VendorsPriceListService {
    constructor(private repository:VendorsPriceListRepository, private adapter:VenPriceListAdapter){
    }

    /**
     * 
     * @param details 
     * @returns VendorPriceListCreateResponse
     */
    async CreateVendorPriceList(details:VendorPriceListInfo):Promise<VendorPriceListCreateResponse>{
        for(const priceList of details.vendorPriceListData){
            const convertedEntity = await this.adapter.ConvertDtoToEntity(priceList);
            const response = await this.repository.save(convertedEntity);
        }
        if(details.inActiveItems.length>0){
            const deleteResponse = await this.repository.update({ vendorPriceListId: In(details.inActiveItems) },{isActive:false});
        }
        return new VendorPriceListCreateResponse(true,1111, 'Created Successfully', 'Created Successfully')
    }

    async GetVendorsPriceListForVendor(vendorId:number):Promise<PriceListForVendorResponse>{
        const vendorItems = await this.repository.find({where:{vendors:vendorId},relations:['vendors','items','taxes']});
            if(vendorItems){
                const priceListInfo : VendorPriceListDto[] = [];
                for(const items of vendorItems){
                  const item = new ItemsDropDownDto(items.items.itemId, items.items.itemName);
                  const tax = new TaxDropDownDto(items.taxes.taxId, items.taxes.taxName);
                  const priceList = new VendorPriceListDto(items.vendors.vendorId, item, tax, items.unitPrice, items.discountPercentage, items.discountPrice, items.actualPrice, items.skuCode, items.createdUser, items.isActive, items.vendorPriceListId, items.updatedUser, items.versionFlag); 
                  priceListInfo.push(priceList); 
                }
                return new PriceListForVendorResponse(true, 1111, 'Item Details Found For Vendor', priceListInfo)
            }else{
                return new PriceListForVendorResponse(false, 1111, 'No Price List Found For User');
            }
    }


    async GetItemPriceTaxForVendorIdItemId(request:VendorItemRequestDto):Promise<GetVendorItemsPriceListResponse>{
        const vendorItems = await this.repository.findOne({where:{vendors:request.vendorId, items:request.itemId, isActive:true},relations:['taxes']});
            if(vendorItems){
                return new GetVendorItemsPriceListResponse(true, 1111, 'Price Details Found Successfully', vendorItems);
            }else{
                return new GetVendorItemsPriceListResponse(false, 9999, 'Price Details Not Found For Vendor', vendorItems);
            }
    }

    async GetVendorPriceListById(id:number){
        const response = await this.repository.findOne({
            where: {vendorPriceListId: id},
            });
            
            if (response) {
            return response;
            } else {
            return null;
            }
    }

    async ActivateOrDeActivateVPL(request:VPLActivateOrDeActiveRequest):Promise<GetVendorItemsPriceListResponse> {
        try {
            const VPLExists = await this.GetVendorPriceListById(request.vendorPriceListId);
            if (VPLExists) {
                if (request.versionFlag !== VPLExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current price list information.Refresh and try again');
                } else {
                    
                        const vplStatus =  await this.repository.update(
                            { vendorPriceListId: request.vendorPriceListId },
                            { isActive: request.isActive,updatedUser: request.updatedUser });
                       
                        if (VPLExists.isActive) {
                            if (vplStatus.affected) {
                                const vplResponse: GetVendorItemsPriceListResponse = new GetVendorItemsPriceListResponse(true, 10115, 'Vendor Price List is de-activated successfully');
                                return vplResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Vendor Price List is already deactivated');
                            }
                        } else {
                            if (vplStatus.affected) {
                                const vplResponse: GetVendorItemsPriceListResponse = new GetVendorItemsPriceListResponse(true, 10114, 'Vendor Price List is activated successfully');
                                return vplResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Vendor Price List is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
}
